var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixSocialGroupsV2GroupRequest from '@wix/ambassador-social-groups-v2-group-request/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var AllowPolicy;
(function (AllowPolicy) {
    AllowPolicy["UNKNOWN"] = "UNKNOWN";
    AllowPolicy["OWNER_AND_ADMINS"] = "OWNER_AND_ADMINS";
    AllowPolicy["OWNER"] = "OWNER";
    AllowPolicy["ALL_MEMBERS"] = "ALL_MEMBERS";
})(AllowPolicy || (AllowPolicy = {}));
export var StepKey;
(function (StepKey) {
    StepKey["UNKNOWN"] = "UNKNOWN";
    StepKey["CREATE_POST"] = "CREATE_POST";
    StepKey["REACT_TO_POST"] = "REACT_TO_POST";
    StepKey["INVITE_MEMBERS"] = "INVITE_MEMBERS";
})(StepKey || (StepKey = {}));
export var PrivacyStatus;
(function (PrivacyStatus) {
    PrivacyStatus["UNKNOWN"] = "UNKNOWN";
    /** Anyone can see the group in the group list and view its content. Anyone can join. */
    PrivacyStatus["PUBLIC"] = "PUBLIC";
    /** Anyone can see the group in the group list, but only group members can see its content. In order to join a group, a group join request must be submitted. */
    PrivacyStatus["PRIVATE"] = "PRIVATE";
    /** Only group members and admins can see the group in the group list. New group members can only be added by existing group members. */
    PrivacyStatus["SECRET"] = "SECRET";
})(PrivacyStatus || (PrivacyStatus = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["USER"] = "USER";
    IdentityType["MEMBER"] = "MEMBER";
})(IdentityType || (IdentityType = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** Cancelled request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
    /** Canceled request. */
    RequestStatus["CANCELED"] = "CANCELED";
})(RequestStatus || (RequestStatus = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _approveGroupRequestsRequest = {};
const _approveGroupRequestsResponse = {};
const _cancelGroupRequestRequest = {};
const _cancelGroupRequestResponse = {};
const _listGroupRequestsRequest = {};
const _listGroupRequestsResponse = {};
const _queryGroupRequestsRequest = {};
const _queryGroupRequestsResponse = {};
const _rejectGroupRequestsRequest = {};
const _rejectGroupRequestsResponse = {};
const _submitGroupRequestRequest = {};
const _submitGroupRequestResponse = {};
/**
 * Submit a group request.
 * Can be used in case `GroupsAppSettings.create_groups_policy` = `MEMBERS_WITH_APPROVAL`.
 * This endpoint doesn't support server signing.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function submitGroupRequest(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { group: '$[0].group' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _submitGroupRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _submitGroupRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['groupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.submitGroupRequest(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Approves requests to create a group.
 *
 * The `approveGroupRequests()` function returns a Promise that resolves when a site member's request to create a group is approved. Only site admins can approve requests to create a group. When the request is approved, the new group is added to the Groups List page of your site.
 *
 * >**Note:** This function is only relevant if admin approval is required for creating a group.
 * @param groupRequestIds - IDs of the requests create groups to approve.
 *
 * Max: 100 create group request IDs
 * @public
 * @documentationMaturity preview
 * @requiredField groupRequestIds
 * @adminMethod
 */
export function approveGroupRequests(groupRequestIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            groupRequestIds: '$[0]',
            itemsToApprove: '$[1].itemsToApprove',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _approveGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _approveGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#groupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupRequestIds, options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.approveGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupRequestIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Rejects a request to create a group.
 *
 * The `rejectGroupRequests()` function returns a Promise that resolves when a member's request to create a group is rejected. Only site admins can reject requests to create a group.
 *
 * >**Note:** This function is only relevant if admin approval is required for creating a group.
 * @param rejections - Rejection data.
 * @public
 * @documentationMaturity preview
 * @requiredField rejections
 * @adminMethod
 */
export function rejectGroupRequests(rejections, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            rejections: '$[0]',
            itemsToReject: '$[1].itemsToReject',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _rejectGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _rejectGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#groupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([rejections, options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.rejectGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'rejections',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Cancels a Group Request.
 * Group managers always have access to this functionality. Site members can cancel their own group requests.
 * This endpoint doesn't support server signing.
 * @param groupRequestId - ID of the Group Request to cancel.
 * @internal
 * @documentationMaturity preview
 * @requiredField groupRequestId
 * @adminMethod
 */
export function cancelGroupRequest(groupRequestId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { groupRequestId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelGroupRequestRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelGroupRequestResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['groupRequest']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([groupRequestId]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.cancelGroupRequest(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'groupRequestId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Lists requests to create a group.
 *
 * The `listGroupRequests()` function returns a Promise that resolves to a list of up to 1,000 create group requests on your site.
 *
 * Using the options parameter, you can filter your list of posts, set the amount of posts to be returned, and sort your list in a specified order.
 *
 * By default, the list is sorted by `_createdDate` in descending order. Only admins can see create group requests. Members can access their own create group requests in their site.
 *
 * >**Note:** This function is only relevant if admin approval is required for creating a group.
 *
 * @public
 * @documentationMaturity preview
 * @param options - Paging options.
 * @adminMethod
 */
export function listGroupRequests(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            ownershipFilter: '$[0].ownershipFilter',
            limit: '$[0].limit',
            offset: '$[0].offset',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listGroupRequestsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listGroupRequestsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#groupRequests']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.listGroupRequests(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of create requests.
 *
 * The `queryGroupRequests()` function builds a query to retrieve a list of all requests to create a group, and returns a `GroupRequestsQueryBuilder` object.
 *
 * The returned object contains the query definition which is typically used to run the query using the [`find()`](/group-requests-query-builder/find) function. You can refine the query by chaining `GroupRequestQueryBuilder` functions onto the query. `GroupRequestQueryBuilder` functions enable you to sort, filter, and control the results that `queryGroupRequests()` returns.
 *
 * `queryGorupRequests()` runs with these `GroupRequestsQueryBuilder` defaults, which you can override:
 * - [`limit(1000)`](/group-requests-query-builder/limit)
 * - [`descending('_createdDate')`](/group-requests-query-builder/descending)
 *
 * The following `GroupRequestsQueryBuilder` functions are supported for `queryGroupRequests()`. For a full description of the `GroupRequests` object, see the object returned for the [`items`](/group-requests-query-result/items) property in `GroupRequestsQueryResult`.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryGroupRequests(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.groupRequests',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryGroupRequestsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryGroupRequestsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#groupRequests']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixSocialGroupsV2GroupRequest.queryGroupRequests(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
//# sourceMappingURL=social-groups-v2-group-request.universal.js.map